/**
 *  Component: Task Details Icon
 */
import React from 'react';

import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import { withRouter } from 'react-router-dom';
import styled, { css } from 'styled-components';
import { NewStyledIconButton } from 'styles/common';

import { getColorFromKey } from 'constants/helper';
import { ChevronRightIcon } from 'constants/icons';

const TaskDetailsIcon = ({ className, taskId, type, showDetails, absolutePosition, color = '#999', ...props }) => (
  <Container
    color={color}
    circular
    onClick={(e) => showDetails(taskId, e, type)}
    absolutePosition={absolutePosition}
    className={className}
    {...props}
  >
    <ChevronRightIcon size="fixed10px" />
  </Container>
);

const Container = styled(NewStyledIconButton)`
  height: 1.5rem;
  width: 1.5rem;
  background: white;
  border: 1px solid ${(props) => getColorFromKey(props.color || props.theme.palette.text.secondary)};
  ${({ absolutePosition }) =>
    absolutePosition &&
    `
      position: absolute;
      right: 10px;
      top: 50%;
      transform: translateY(-50%);
  `}
  ${(props) =>
    props.color &&
    css`
      svg {
        fill: ${getColorFromKey(props.color)};
        margin-left: 1.5px;
      }
    `};
`;

const Icon = styled(KeyboardArrowRightIcon)`
  width: 16px;
`;

export default withRouter(TaskDetailsIcon);
